{
  "Danish": "Danish",
  "English": "English",
  "Estonian": "Estonian",
  "Finnish": "Finnish",
  "German": "German",
  "Latvian": "Latvian",
  "Lithuanian": "Lithuanian",
  "Norwegian": "Norwegian",
  "Russian": "Russian",
  "Swedish": "Swedish",
  "Ukrainian": "Ukrainian"
}
